import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../consts';
import { validateEmail, validatePassword } from '../util';


const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [emailBorderColor, setEmailBorderColor] = useState('#353A40');
    const [passwordBorderColor, setPasswordBorderColor] = useState('#353A40');
    const [emailImg, setEmailImg] = useState("./ula.png");
    const [passwordImg, setPasswordImg] = useState("./unhidden.png");
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState(null)

    const [check1, setCheck1] = useState(false)

    // const validateEmail = (email) => {
    //     const re = /^[^s@]+@[^s@]+.[^s@]+$/;
    //     return re.test(String(email).toLowerCase());
    // };

    // const validatePassword = (password) => {
    //     return password.length >= 8;
    // };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (validateEmail(value)) {
            setEmailBorderColor('#34C759'); // зеленый при валидном email
            setEmailImg("./Succes.png");
        } else {
            setEmailBorderColor('#C3372E'); // красный при ошибке
            setEmailImg("./dot-error.png");
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (validatePassword(value)) {
            setPasswordBorderColor('#34C759'); // зеленый при валидном пароле
            setPasswordImg(isVisible ? "./hidden.png" : "./unhidden.png");
        } else {
            setPasswordBorderColor('#C3372E'); // красный при ошибке
            setPasswordImg("./hidden-error.png");
        }
    };

    const togglePasswordVisibility = () => {
        setIsVisible(!isVisible);
        // Обновляем изображение в зависимости от состояния видимости
        if (!isVisible) {
            setPasswordImg("./hidden.png"); // Показываем скрытый значок
        } else {
            setPasswordImg("./unhidden.png"); // Показываем открытый значок
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // предотвращаем перезагрузку страницы

        if (!validateEmail(email) || !validatePassword(password)) {
            setErrorMessage('Пожалуйста, проверьте введенные данные.');
            return;
        }

        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                let err = new Error('Ошибка при входе в систему');
                err.response = response;
                throw err;
            }

            const data = await response.json();
            console.log('Успешный вход:', data);
            window.location.replace("/primary")
            // Здесь можно добавить логику для перехода на другую страницу или сохранения токена

        } catch (error) {
            console.error('Ошибка:', error);
            setErrorMessage(error.message); // Показать ошибку пользователю
            if (error.response && error.response.status === 401) {
                setError("Пользователь не найден");
            } else {
                setError("Произошла ошибка. Попробуйте еще раз.");
            }
        }
    };
    return (
        <>
            <div className='w-full p-8 h-screen hidden lg:grid lg:grid-cols-2'>
                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Войдите в кабинет</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные аккаунта</span>
                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div className='w-[60%] text-[#4B535B] gap-4 flex flex-row'>
                        <div onClick={() => setCheck1(!check1)} style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span onClick={() => setCheck1(!check1)} className='text-[12px]'>Запомнить меня</span>
                        <a href="/recovery " className='mb-auto ml-auto h-fit font-semibold hover:text-[#353A40] text-[#626C75]'><span className='text-[14px]'>Забыли пароль?</span></a>
                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='flex flex-row justify-between rounded-full w-[60%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px]'>Войти</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            Еще не с нами?
                        </span>


                        <a href="/registration">
                            <span className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                                Зарегистрироваться
                            </span>
                        </a>
                    </div>



                </div>

                <img style={{ aspectRatio: 1 }} className='w-full my-auto' src='/AuthBg.png' />
            </div>












            <div className='w-full p-8 min-h-screen hidden sm:grid lg:hidden lg:grid-cols-1'>
                <img className='w-full my-auto' src='/AuthBgLaptop.png' />

                <div className='w-full h-full mt-8 gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Войдите в кабинет</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные аккаунта</span>
                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div onClick={() => setCheck1(!check1)} className='w-[80%] text-[#4B535B] gap-4 flex flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>Запомнить меня</span>
                        <a href="/recovery " className='mb-auto ml-auto h-fit font-semibold hover:text-[#353A40] text-[#626C75]'><span className='text-[14px]'>Забыли пароль?</span></a>

                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='flex flex-row justify-between rounded-full w-[80%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px]'>Войти</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8' onClick={() => window.location.replace('./registration')}>
                        <span className='text'>
                            Еще не с нами?
                        </span>

                        <span className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                            Зарегистрироваться
                        </span>
                    </div>



                </div>

            </div>









            <div className='w-full p-8 min-h-screen grid sm:hidden lg:grid-cols-1'>

                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Войдите в кабинет</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные аккаунта</span>
                    <div className={`py-2 px-4 w-[95%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[95%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div onClick={() => setCheck1(!check1)} className='w-[95%] text-[#4B535B] gap-4 flex flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>Запомнить меня</span>
                        <a href="/recovery " className='mb-auto ml-auto h-fit font-semibold hover:text-[#353A40] text-[#626C75]'><span className='text-[14px]'>Забыли пароль?</span></a>

                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='flex flex-row justify-between rounded-full w-[95%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px]'>Войти</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            Еще не с нами?
                        </span>

                        <a href="/registration" className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                            Зарегистрироваться
                        </a>
                    </div>



                </div>
                <img className='w-full mt-8 my-auto' src='/AuthBgMobile.png' />

            </div>
        </>

    );
};

export default Login;

